import QueryString from "qs";
import dynamic from "next/dynamic";

const Header = dynamic(() => import('../../layout/common/header'));
const Troofooter = dynamic(() => import('../../layout/common/troofooter'));
const CaseStudyPage = dynamic(() => import('../../components/pages/CaseStudyPage'));

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps = async (ctx) => {
	if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
		ctx.res.setHeader(
			'Cache-Control',
			'public, s-maxage=1800, stale-while-revalidate=59'
		)
	}
	const slug = ctx.params.slug;

	let apiRes = null;
	let apiResData = null;
	const query = QueryString.stringify(
		{
			filters: {
				slug: {
					$eq: slug
				}
			},
			populate: "deep, 8"
		},
		{
			encodeValuesOnly: false
		}
	);
	// apiRes = await fetch(`${baseUrl}case-studies?${decodeURIComponent(query)}`);
	apiRes = await fetch(`${baseUrl}case-studies-v2?${decodeURIComponent(query)}`);
	apiResData = await apiRes.json();

	return {
		props: {
			apiResData,
			slug
		}
	}
}

// let NewComponent = null;
const CaseStudy = ({ apiResData, slug }) => {

	return (
		<div id='root'>
			<Header />
			<div className="middle-sction middle-pad">
				<CaseStudyPage slug={slug} data={apiResData} />
			</div>

			<Troofooter />
		</div>
	)
}

export default CaseStudy